import React from 'react';
import { getAlertSeverityColor } from '../../utils/colorHelpers';

interface AlertItem {
    id: string;
    severity: 'high' | 'medium' | 'low';
    message: string;
    timestamp: string;
    category: string;
}

export const AlertCard: React.FC<{ alert: AlertItem }> = ({ alert }) => {
    return (
        <div className={`p-4 rounded-lg ${getAlertSeverityColor(alert.severity)}`}>
            <div className="flex items-start justify-between">
                <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                        <span className={`px-2 py-0.5 rounded text-xs font-bold ${alert.severity === 'high' ? 'bg-red-600 text-white' :
                            alert.severity === 'medium' ? 'bg-amber-600 text-white' :
                                'bg-blue-600 text-white'
                            }`}>
                            {alert.severity.toUpperCase()}
                        </span>
                        <span className="text-xs text-gray-600 dark:text-gray-400">
                            {alert.category}
                        </span>
                    </div>
                    <p className="text-gray-900 dark:text-white font-medium">
                        {alert.message}
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                        {alert.timestamp}
                    </p>
                </div>
                <button className="ml-4 px-3 py-1 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition-colors">
                    Investigate
                </button>
            </div>
        </div>
    );
};
